import React, { useState, useEffect } from 'react';

import CustomCheckBox from '../../customCheckBox';
import API from '../../../services/api';
import { useSelector } from 'react-redux';
import { getSelectedProject } from '../../../redux/projects/actions';

const SelectData = ({ newReport, updateReport, customProject }) => {
  // const solutionSchema = utils.get(newReport, 'solution.schema') || [];
  // const schemas = solutionSchema.map(schema => {
  //   return schema.name;
  // });
  const [schemas, setSchemas] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState(schemas ? [...schemas] : []);
  const selectedProject = useSelector(getSelectedProject);
  const project = customProject || selectedProject;

  useEffect(() => {
    updateReport({ ...newReport, fields: selectedColumns });
  }, [selectedColumns]);

  useEffect(() => {
    let active = true;
    setSchemas([]);
    setSelectedColumns([]);
    API.getReportFields(newReport.cmsId, newReport.solutions, project.isBrandPortal ? null : project.id)
      .then(response => {
        if (active) {
          setSchemas(response.fields || []);
          setSelectedColumns(response.fields || []);
        }
      })
      .catch(error => {
        if (active) console.error(error);
      });
    return () => { active = false; };
  }, [newReport.solutions, newReport.cmsId, project.id, project.isBrandPortal]);

  // TODO: export to a common file
  const isSelected = columnId => {
    return selectedColumns.some(column => column === columnId);
  };

  // TODO: export to a common file
  const toggleSelection = (id, remove) => {
    if (remove) {
      const newColumns = selectedColumns.filter(column => column !== id);
      setSelectedColumns([...newColumns]);
    } else {
      setSelectedColumns([...selectedColumns, id]);
    }
  };

  return (
    <div className="select-data">
      <h3>Your CSV Report will include:</h3>
      <div className="csv-columns">
        {schemas.map(column => {
          return (
            <div className="csv-column" key={`solution-schema-${column}`}>
              <CustomCheckBox
                label={column}
                selected={isSelected(column) ? 'all' : 'none'}
                onClick={value => toggleSelection(column, value)}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SelectData;
